import { render, staticRenderFns } from "./FilterPage.vue?vue&type=template&id=01a2e8bf&scoped=true&"
import script from "./FilterPage.vue?vue&type=script&lang=js&"
export * from "./FilterPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a2e8bf",
  null
  
)

export default component.exports